import WedgesRecommendation from './WedgesRecommendation';

export default WedgesRecommendation;
